import React from 'react';
import CategoryLandingTemplate from '../../components/CategoryLandingTemplate';
import tecnalData from '../../data/tecnal';

const AceiteVegetalPage = () => {
  return <CategoryLandingTemplate data={tecnalData['aceite-vegetal']} />;
};

export default AceiteVegetalPage;
